import { Checkbox, Typography } from '@arionbanki/arionui';
import { Footer } from 'components';
import { FLOW_TYPE } from 'consts/flows';
import { hasLabel, isRiskLevelAllowed } from 'helpers';
import get from 'lodash/get';
import map from 'lodash/map';
import replace from 'lodash/replace';
import { RiskQLegend } from './RiskQLegend';
import { RiskqResultsProfileBox } from './RiskqResultsProfileBox';
import type { RiskqResultsProps } from './useRiskqResults';

const FLOW_TYPES_WITH_IMAGE = {
	[FLOW_TYPE.EB]: true,
	[FLOW_TYPE.ER]: true,
	[FLOW_TYPE.RR_EB]: true,
	[FLOW_TYPE.RR_ER]: true
};

export function RiskQResultsForm(props: RiskqResultsProps) {
	const { data, entityType, flowType, goBack, handleSubmit, isConfirmed, t, ...ctx } = props;

	if (!data) return null;

	const desiredFlowType = replace(flowType, 'rr-', '');
	const id = get(data.recomendedRiskProfile, 'id');
	const secondary = flowType in FLOW_TYPES_WITH_IMAGE;
	const prefix = `${desiredFlowType}_${entityType}_`;
	const selectedProfileTitle = t(`${prefix}selected_profile_title`, 'riskq_results');
	const restOfProfilesTitle = t(`${prefix}rest_of_profiles_title`, 'riskq_results');
	const currentLabel = t(`${prefix}current_label`, 'riskq_results');

	const confirmationLabel =
		id === ctx.selectedRiskProfileId
			? t(`${prefix}folded_checkbox_description_reccommended_risk_profile`, 'riskq_results')
			: t(`${prefix}folded_checkbox_description_new_risk_profile`, 'riskq_results');

	return (
		<form onSubmit={handleSubmit}>
			<Typography className="margin--20" TagName="h6">
				{selectedProfileTitle}
			</Typography>
			{data.recomendedRiskProfile && (
				<RiskqResultsProfileBox
					{...data.recomendedRiskProfile}
					hendleClick={ctx.setSelectedRiskProfileId}
					isChecked={ctx.selectedRiskProfileId === id}
					label={data?.previousRiskProfile?.id === id ? currentLabel : ''}
					withImage={secondary}
				/>
			)}
			{(data.recomendedRiskProfile || data.riskProfilesAvaliableForUser) && (
				<RiskQLegend
					className="mb-5"
					firstDescrption={t('first_color_descrption', 'riskq_results')}
					secondDescription={t('second_color_description', 'riskq_results')}
				/>
			)}
			{data.riskProfilesAvaliableForUser && (
				<>
					<Typography TagName="h6">{restOfProfilesTitle}</Typography>
					<div className="row">
						<div className="col-12">
							{map(
								data.riskProfilesAvaliableForUser,
								profile =>
									data.recomendedRiskProfile && (
										<RiskqResultsProfileBox
											{...profile}
											disabled={!isRiskLevelAllowed(data.recomendedRiskProfile.name, profile.name)}
											hendleClick={ctx.setSelectedRiskProfileId}
											isChecked={ctx.selectedRiskProfileId === profile.id}
											key={profile.id}
											label={
												hasLabel(data.recomendedRiskProfile.id, profile.id, data.previousRiskProfile)
													? currentLabel
													: ''
											}
											withImage={secondary}
										/>
									)
							)}
						</div>
					</div>
				</>
			)}
			<div className="row">
				<div className="col-12 mt-4">
					<Checkbox
						checked={isConfirmed}
						id="confirmation"
						label={confirmationLabel}
						name="confirmation"
						onChange={x => ctx.setIsConfirmed(!!x)}
					/>
				</div>
			</div>
			<Footer
				handleNext={handleSubmit}
				handlePrev={goBack}
				isDisabled={ctx.submitDisabled}
				next={t('continue')}
				prev={t('back')}
			/>
		</form>
	);
}
